import { Action } from 'redux';
import { RootState } from '.';
import { useSelector } from 'react-redux';

export const VIEW_MODE = 'VIEW_MODE';

var view_mode = localStorage.getItem("view_mode");

const initialState: string = view_mode || 'desktop';

export interface ViewModeAction extends Action {
    type: typeof VIEW_MODE;
    payload: string;
}

export function changeViewModeAction(viewMode: string): ViewModeAction {
    localStorage.setItem('view_mode', viewMode);
    return {
        type: VIEW_MODE,
        payload: viewMode
    };
}

export function viewModeReducer(state = initialState, action: ViewModeAction): string {
    switch (action.type) {
        case VIEW_MODE:
            return action.payload;
        default:
            return state;
    }
}

export function useViewMode(): string {
    const viewModeLocalStorage = localStorage.getItem('view_mode');
    const viewModeRedux = useSelector((root: RootState) => root.viewMode);
    return viewModeLocalStorage ? viewModeLocalStorage : viewModeRedux;
}